module.exports = __webpack_public_path__ + "assets/4165c2a0bcb41395330c4b378142769d.png";